// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/ExecutionChecklist.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, bodyTextStyle, displayValue } from "./ExecutionSummaryCard";

function groupByPhase(steps) {
  return (Array.isArray(steps) ? steps : []).reduce((groups, step) => {
    const phase = step?.phase || "Execution";
    if (!groups[phase]) groups[phase] = [];
    groups[phase].push(step);
    return groups;
  }, {});
}

export default function ExecutionChecklist({ steps = [] }) {
  const groups = groupByPhase(steps);
  const phases = Object.keys(groups);

  if (!phases.length) {
    return <EmptyPanel title="No checklist steps" message="Execution checklist steps were not returned for this task yet." />;
  }

  return (
    <ExecutionPlanSection eyebrow="Checklist" title="Operator execution checklist" badge={`${steps.length} steps`}>
      <div style={{ display: "grid", gap: 12 }}>
        {phases.map((phase) => (
          <div key={phase} style={{ border: "1px solid rgba(148, 163, 184, 0.16)", borderRadius: 14, padding: 12, background: "rgba(2, 6, 23, 0.24)" }}>
            <strong style={{ color: "#f8fafc", display: "block", marginBottom: 10 }}>{phase}</strong>
            <div style={{ display: "grid", gap: 10 }}>
              {groups[phase].map((step, index) => (
                <label key={`${phase}-${index}`} style={{ display: "grid", gridTemplateColumns: "22px 1fr", gap: 10, alignItems: "start" }}>
                  <input type="checkbox" disabled style={{ marginTop: 3 }} />
                  <span>
                    <strong style={{ color: "#dbeafe", display: "block", fontSize: 13 }}>{displayValue(step.title, `Step ${index + 1}`)}</strong>
                    <span style={bodyTextStyle}>{displayValue(step.detail, "No detail returned.")}</span>
                    {step.target ? <small style={{ color: "#93c5fd", display: "block", marginTop: 4 }}>{displayValue(step.target)}</small> : null}
                  </span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </ExecutionPlanSection>
  );
}
